// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';
import { secureRouteBuilder } from '../secure-route';
import NewIncident from './single-ui-bvt-wrappers/new-incident';
import { IncidentsList } from './pages/incident-list/index-lazy';
import { resetLastVisitedIncidentView } from '@applications/incidents/store-state';
import UnifiedTrackView from './single-ui-bvt-wrappers/unified-track-view';
import IncidentDetails from './single-ui-bvt-wrappers/incident-details';
import Routes from './route-constants';
import { IApplicationDefinition, IAppRegistry } from '@apps-config/app-definition';
import { Activity } from '@utils/activity-tracking';
import IncidentTile from './single-ui-bvt-wrappers/incident-tile';
import { RoutesHelper } from '@apps-config/routing/routing';
import { ApplicationName } from '@telstra-connect/tickets/activity-tracking';
import global from '@applications';
import { CreateGuestIncident } from './guest/create-incident/index-lazy';
import { TrackGuestIncidents } from './guest/track-incidents/index-lazy';
import { ViewGuestIncident } from './guest/view-incident/index-lazy';
import { GuestCard } from './guest/dashboard-card/index-lazy';

const routes = new RoutesHelper({
    rootPath: secureRouteBuilder(Routes.Tickets),
    subpagesPathMask: secureRouteBuilder(Routes.Tickets)
});

const applicationName = ApplicationName;
const menuItemName = 'Incidents';
const tracker = Activity.createTracker(applicationName);

export const Application: IApplicationDefinition = {
    get applicationName() {
        return applicationName;
    },

    get acceptsUserFeedback() {
        return true;
    },

    get acceptsErrorReports() {
        return true;
    },

    get card() {
        if (global?.TCONN?.isGuestUser) {
            return GuestCard;
        }
        return IncidentTile;
    },

    get unifiedTrackView() {
        return UnifiedTrackView;
    },

    get tracker() {
        return tracker;
    },

    get routes() {
        return routes;
    },

    init(registry: IAppRegistry, availableToUser: boolean) {
        if (availableToUser) {
            registry.add(Application);
        }
    },

    render() {
        if (global?.TCONN?.isGuestUser) {
            return [{
                path: routes.getPageSubpath(Routes.CreateGuestIncidentRoute),
                component: CreateGuestIncident
            }, {
                path: routes.getPageSubpath(Routes.TrackGuestIncidentsRoute),
                component: TrackGuestIncidents
            }, {
                path: routes.getPageSubpath(Routes.ViewGuestIncidentRoute),
                component: ViewGuestIncident
            }];
        }

        return [
            {
                path: routes.getPageSubpath(Routes.NewTicket),
                component: NewIncident
            },
            {
                path: routes.getPageSubpath(Routes.MajorIncidentRoute),
                component: IncidentDetails
            },
            {
                path: routes.getPageSubpath(Routes.ViewIncidentsClosedRoute),
                component: IncidentDetails
            },
            {
                path: routes.getPageSubpath(Routes.ViewIncidentsOpenRoute),
                component: IncidentDetails
            },
            {
                path: routes.getPageSubpath(Routes.ViewIncidentsRoute),
                component: IncidentDetails
            },
            {
                path: routes.getAppPath(),
                component: IncidentsList
            }
        ];
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    menuItem(state, navigate) {

        return [
            {
                name: 'Submit',
                testID: 'ui-menu-incidents',
                appPath: routes.getAppPath(),
                intialPagePath: routes.getInitialPagePath(),
                onClick: () => {
                    resetLastVisitedIncidentView(); Application.tracker.trackMenu(menuItemName);
                },
                subMenus: [{
                    name: 'Incident',
                    active: false,
                    icon: '',
                    onClick: () => navigate(routes.getPageSubpath(Routes.NewTicket))
                }]
            },
            {
                name: 'Track',
                testID: 'ui-menu-incidents',
                appPath: routes.getAppPath(),
                intialPagePath: routes.getInitialPagePath(),
                onClick: () => {
                    resetLastVisitedIncidentView(); Application.tracker.trackMenu(menuItemName);
                },
                subMenus: [{
                    name: 'Incidents',
                    active: false,
                    icon: '',
                    onClick: () => navigate(routes.getInitialPagePath())
                }]
            }
        ];
    }
};

export type { ITicketsAppState } from './store-state';
